/**
 * The three states every async surface needs, drawn as finixt-ui's.
 *
 * Loading is a skeleton rather than a spinner: it holds the shape of what is
 * coming, so the page does not jump when data lands. The error keeps
 * `role="alert"`, which finixt-ui's ErrorState does not set, so a failed
 * query is still announced. Empty is finixt-ui's EmptyState, compact and
 * bordered, with the caller's sentence as its title.
 */
import type { ReactNode } from 'react';

import { EmptyState, ErrorState, Skeleton } from './finixt.js';

export function LoadingBlock() {
  return (
    <div aria-busy="true" aria-live="polite" style={{ padding: '7px 0' }}>
      <Skeleton lines={3} />
    </div>
  );
}

export function ErrorBlock({ message }: { message: string }) {
  return (
    <div role="alert">
      <ErrorState compact body={message} />
    </div>
  );
}

export function EmptyBlock({ children }: { children: ReactNode }) {
  return <EmptyState compact bordered title={children} />;
}
